import { useEffect } from "react"
// import ProcessingAnimation from "../Processing/ProcessingAnimation"

const Preview = ({ videoUrl, onPreviewReadyChange }) => {
  const previewSrc = videoUrl

  useEffect(() => {
    onPreviewReadyChange?.(false)
  }, [previewSrc, onPreviewReadyChange])

  const handlePreviewReady = () => {
    onPreviewReadyChange?.(true)
  }

  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flex: "1 1 auto",
        minHeight: 0,
      }}
    >
      <div
        css={{
          position: "relative",
          borderRadius: 8,
          background: "rgba(0, 0, 0, 0.20)",
          backdropFilter: "blur(10px)",
          boxShadow: "0px 0px 16px 0px #000",
          height: "100%",
          width: "100%",
          color: "gray",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        {!previewSrc ? (
          // <ProcessingAnimation />
          <div>Processing...</div>
        ) : (
          <video
            key={previewSrc}
            width="100%"
            controls
            autoPlay={false}
            playsInline
            preload="metadata"
            src={previewSrc}
            onLoadedMetadata={handlePreviewReady}
            onCanPlay={handlePreviewReady}
            onLoadedData={handlePreviewReady}
            onError={() => onPreviewReadyChange?.(false)}
            css={{
              borderRadius: 8,
              objectFit: "contain",
              height: "100%",
              maxHeight: "100%",
            }}
          >
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  )
}

export default Preview
